import {Component} from 'react';
import h from 'react-hyperscript';
import './Header.scss';
import Nav from 'Components/Header/Nav/Nav';
import NavbarUpper from 'Components/Header/NavbarUpper/NavbarUpper';
import AuthButtons from 'Components/Header/AuthButtons/AuthButtons';

class Header extends Component {
  render() {
    return (
      h('header', {
        id: 'header',
        className: 'header',
      }, [

        h(NavbarUpper, null, null),

        h('div', {
          className: 'header__lower',
        }, [

          h(Nav, {
            id: 'header__nav-upper--desktop',
            key: 'header__nav-upper--desktop',
            userStatus: this.props.userStatus,
            googleUser: this.props.googleUser,
            logoutClick: this.props.logoutClick,
            loginClick: this.props.loginClick,
            handleSettingsOpen: this.props.handleSettingsOpen,
            needsDistrictConfig: this.props.needsDistrictConfig,
            mobileLogin: this.props.mobileLogin,
            isAdmin: this.props.isAdmin,
          }, null),

          !this.props.maintenanceMode ? h(AuthButtons, {
            key: 'nav__auth-buttons__key',
            csrf: this.props.csrf,
            className: 'nav__list--desktop',
            isAdmin: this.props.isAdmin,
            isLoggedIn: this.props.isLoggedIn,
            googleUser: this.props.googleUser,
            logoutClick: this.props.logoutClick,
            loginClick: this.props.loginClick,
            loginBtnId: 'header__goog-login-button',
            logoutBtnId: 'header__goog-logout',
            userStatus: this.props.userStatus,
            needsDistrictConfig: this.props.needsDistrictConfig,
            handleSettingsOpen: this.props.handleSettingsOpen,
          }, null) : null,
        ]),
        h('div', {
          key: 'header__sunset_message',
          id: 'header__sunset_message',
          className: 'header__sunset--message',
          tabIndex: 0,
        }, `The creation of new Transformation Reports will no longer
            be available as this site has been depreciated.
            Past Transformation reports can still be downloaded.`),
      ])
    );
  }
}

export default Header;
